<template>
  <div class="video-page-wrapper">
    <IphoneVideo
      :video-name="require('@/assets/videos/automation.mp4')"
    ></IphoneVideo>
    <div class="video-page-texts">
      <div>
        <h3>{{ $t("pages.automation.subtitle1") }}</h3>
        <p>{{ $t("pages.automation.text1") }}</p>
      </div>
      <div>
        <h3>{{ $t("pages.automation.subtitle2") }}</h3>
        <p>{{ $t("pages.automation.text2") }}</p>
        <div class="items">
          <div class="item" v-for="(trigger, i) in triggers" :key="i">
            <img :src="require(`@/assets/icons/${trigger.icon}.svg`)" />
            <p>{{ trigger.text }}</p>
          </div>
        </div>
      </div>
      <div>
        <h3>{{ $t("pages.automation.subtitle3") }}</h3>
        <p>{{ $t("pages.automation.text3") }}</p>
        <div class="items">
          <div class="item" v-for="(condition, i) in conditions" :key="i">
            <img :src="require(`@/assets/icons/${condition.icon}.svg`)" />
            <p>{{ condition.text }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Scenes",
  data() {
    return {
      triggers: [
        { icon: "automation", text: this.$t("pages.automation.items.time") },
        { icon: "device-state", text: this.$t("pages.automation.items.state") },
        { icon: "location", text: this.$t("pages.automation.items.location") },
        { icon: "alarm", text: this.$t("pages.automation.items.alarms") },
        { icon: "presence", text: this.$t("pages.automation.items.presence") }
      ],
      conditions: [
        { icon: "automation", text: this.$t("pages.automation.items.time") },
        { icon: "presence", text: this.$t("pages.automation.items.presence") }
      ]
    };
  }
};
</script>

<style scoped lang="scss">
@import "../common/_variables.scss";

.items {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin-top: 20px;
  justify-content: flex-start;
  img {
    width: 50px;
    height: 50px;
  }
  p {
    text-align: center;
    margin-bottom: 0;
    color: $color-gray;
    font-size: 14px;
  }
  .item {
    width: 100px;
    height: 100px;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 5px 5px;
  }
}
@media only screen and (max-width: $screen-md) {
  .items {
    margin-bottom: 0px;
    margin-top: 20px;
  }
}
</style>
